import React from 'react'
import Footer from '../components/Footer'

function ContactUs() {
  return (
    <div>ContactUs

      <Footer/>
    </div>
  )
}

export default ContactUs